module.exports = __webpack_public_path__ + "img/main_masterkong.bcbd7453.png";